import { render, staticRenderFns } from "./SettingsProducts.vue?vue&type=template&id=b43b2a36&scoped=true&"
import script from "./SettingsProducts.vue?vue&type=script&lang=js&"
export * from "./SettingsProducts.vue?vue&type=script&lang=js&"
import style0 from "./SettingsProducts.vue?vue&type=style&index=0&id=b43b2a36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b43b2a36",
  null
  
)

export default component.exports